<template>
    <div v-if="type === 'buy'" class="billDetail">
        <div class="view">
            <div class="typeView">
                <span>设备类型</span>
                <span>设备类编号</span>
                <span>设备归属</span>
            </div>
            <div class="productView">
                <div class="productItem" v-for="(item, index) in results.powerBankTransItemList" :key="index">
                    <span>{{item.deviceType && item.deviceType.desc}}</span>
                    <span>{{item.powerBankSn}}</span>
                    <span>{{item.originalAgentName}}</span>
                </div>
            </div>
            <p class="orderSn">订单号：{{results.sn}}</p>
            <div class="countView">
                <div class="countItem">
                    <span>合计数量</span>
                    <span>{{results.powerBankNum}}台</span>
                </div>
                <div class="countItem">
                    <span>付款金额</span>
                    <span class="c67b2fd">{{results.payAmount}}元</span>
                </div>
                <div class="countItem">
                    <span>购买时间</span>
                    <span>{{results.payTime}}</span>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="billDetail">
        <div class="view" v-for="(item, index) in results.powerBankTransItemList" :key="index">
            <div class="header">
                <span>购买对象</span>
                <span class="c67b2fd">{{item.nowAgentName}}</span>
            </div>
            <div class="countView">
                <div class="countItem">
                    <span>设备类型</span>
                    <span>{{item.deviceType && item.deviceType.desc}}</span>
                </div>
                <div class="countItem">
                    <span>设备ID</span>
                    <span>{{item.powerBankSn}}</span>
                </div>
                <div class="countItem">
                    <span>设备单价</span>
                    <span>{{item.amount}}元</span>
                </div>
                <div class="countItem">
                    <span>设备数量</span>
                    <span class="c67b2fd">{{results.powerBankNum}}台</span>
                </div>
            </div>
        </div>
        <div class="view">
            <div class="header">
                <span>订单号：{{results.sn}}</span>
            </div>
            <div class="countView">
                <div class="countItem">
                    <span>付款金额</span>
                    <span class="c67b2fd">{{results.payAmount}}元</span>
                </div>
                <div class="countItem">
                    <span>购买时间</span>
                    <span>{{results.payTime}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /*
    * 账单详情
    * */
    import {getBillDetail} from "../../../../api/bill";

    export default {
        name: "BillDetail",
        data() {
            return {
                type: '',
                results: {}
            }
        },
        created() {
            let {type, id} = this.$route.params;
            this.type = type;
            this.id = id;
            getBillDetail(this.id).then(res => {
                console.log(res);
                this.results = res;
            })
        }
    }
</script>

<style lang='less' scoped>
    .billDetail {
        min-height: 100vh;
        padding-top: 2.67vw;
        background-color: #f8f8f8;
        box-sizing: border-box;
        .c67b2fd {
            color: #67b2fd;
        }
        .view {
            width: 93.87vw;
            margin: 0 auto 2.67vw;
            padding: 0 4.67vw 0 5.73vw;
            background-color: #ffffff;
            box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
            border-radius: 2.67vw;
            box-sizing: border-box;
            .header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 8.13vw;
                padding: 0 1.2vw;
                border-bottom: 0.27vw dotted #979797;
                font-size: 3.2vw;
                color: #999999;
            }
            .typeView {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 1.3vw;
                height: 8.13vw;
                font-size: 3.2vw;
                color: #999999;
            }
            .productView {
                border: 0.27vw dotted #979797;
                border-right: none;
                border-left: none;
                .productItem {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 7vw;
                    padding: 0 1.3vw;
                    font-size: 3.2vw;
                    color: #333333;
                }
            }
            .orderSn {
                line-height: 7vw;
                font-size: 3.2vw;
                color: #999999;
                text-indent: 1.2vw;
            }
            .countView {
                padding: 0 1.2vw;
                .countItem {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 7vw;
                    font-size: 3.2vw;
                    color: #333333;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/bill/billDetail/BillDetail.vue